// extracted by mini-css-extract-plugin
export default {"ben_Container":"Ben_ben_Container__HlMGM","ben_Wrapper":"Ben_ben_Wrapper__aVvN+","ben_Link":"Ben_ben_Link__G2MqH"};